<template>
<div class="modules">
    <div class="security-container">
        <div class="summary">
            <h1 class="title"> {{ $t("lang.Security") }}</h1>
            <div class="metas">

            </div>
        </div>
        <div class="mod">
            <!-- <div class="hd">
                <h3 class="title">Two-Factor Authentication(2FA)</h3>
            </div> -->
            <div class="bd">
                <ul class="list">
                    <li>
                        <div class="item">
                            <div class="item-icon">
                                <img class="img" :src="require('@/assets/img/secure_2fa.svg')" />
                            </div>
                            <div class="item-info">
                                <div class="info-title">{{ $t("lang.Authentication") }}</div>
                            </div>
                            <div class="item-status">
                                <div class="status  status-success" v-if="!userInfo.doubleCheck">
                                    <i class="status-icon el-icon-error"></i>
                                    <span class="text" >{{ $t("lang.OFF") }}</span>
                                </div>
                                <div class="status  status-success" v-else>
                                    <i class="status-icon el-icon-success"></i>
                                    <span class="text" >{{ $t("lang.ON") }}</span>
                                </div>
                            </div>
                            <div class="item-action">
                                <el-popconfirm  :title="$t('lang.enable')" :confirm-button-text="$t('lang.confirmText')" :cancel-button-text="$t('lang.cancelText')" @confirm="confirm"  >
                                    <el-button slot="reference" size="mini">{{ $t("lang.Enable") }}</el-button>
                                </el-popconfirm>
                                
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <div class="item-icon">
                                <img class="img" :src="require('@/assets/img/secure_email.svg')" />
                            </div>
                            <div class="item-info">
                                <div class="info-title">{{ $t("lang.Email") }}</div>
                                <div class="info-description">
                                    {{ $t("lang.account") }}
                                </div>
                            </div>
                            <div class="item-status">
                                <div class="status status-success">
                                    <i class="status-icon el-icon-success"></i><span class="text">{{userInfo.email}}</span>
                                </div>
                                <!-- <div class="status status-error">
                                    <i class="status-icon el-icon-error"></i><span class="text"></span>
                                </div>
                                <div class="status status-warning">
                                    <i class="status-icon el-icon-warning"></i><span class="text"></span>
                                </div> -->
                            </div>
                            <div class="item-action">
                                <el-button size="mini" @click="modifyEmail(userInfo)">{{ $t("lang.Manage") }}</el-button>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="item">
                            <div class="item-icon">
                                <img class="img" :src="require('@/assets/img/secure_pwd.svg')" />
                            </div>
                            <div class="item-info">
                                <div class="info-title">{{ $t("lang.LoginPassword") }}</div>
                                <div class="info-description">
                                    {{ $t("lang.textPassword") }}
                                </div>
                            </div>
                            <div class="item-status"></div>
                            <div class="item-action">
                                <el-button size="mini" @click="modifyPwd(userInfo)">{{ $t("lang.Manage") }}</el-button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <email-modify-dialog ref="emailDialog" @ok="rest"></email-modify-dialog>
    <password-modify-dialog ref="pwdDialog" @ok="rest"></password-modify-dialog>
</div>
</template>
<script>
import emailModifyDialog from './modules/emailModifyDialog.vue';
import passwordModifyDialog from './modules/passwordModifyDialog.vue';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet,axiosPost} from '@/api/api';
export default {
    name:'security',
    components:{
        emailModifyDialog,
        passwordModifyDialog,
    },
    data(){
        return {
           
            url:{
                sendCode:BASE_GLOB_API+'/register/verifyCode/send',
                edit:BASE_GLOB_API+'/user/edit',
                info:BASE_GLOB_API+'/user/info',
            },
            lang: "",
            userInfo:{}
        }
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        this.useInfo()
    },
    methods:{
        confirm(){
            axiosPost(this.url.edit,{doubleCheck: !this.userInfo.doubleCheck}).then(res=>{
              if(res.success){
                this.useInfo() 
              }else{
                  this.$message.error(res.message);
              }
              
          })
        },
        rest(){
            this.useInfo() 
        },
        useInfo(){
          
          axiosGet(this.url.info).then(res=>{
              this.twoFALoading = false;
              if(res.success){
                  this.userInfo =res.result
                  window.sessionStorage.setItem("userinfo", JSON.stringify(this.userInfo));
              }else{
                  this.$message.error(res.message);
              }
              
          })
      },
       
        modifyEmail(userInfo){
            this.$refs.emailDialog.open(userInfo);
        },
        modifyPwd(userInfo){
            this.$refs.pwdDialog.open(userInfo);
        }
    }
}
</script>
<style lang="less" scoped>
.security-container {
    .summary {
        background:#f4f5f6 url(~@/assets/img/bg_security.svg) no-repeat 94% center/60px 60px; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
    }
    .mod {
        .hd {
            .title {
                font-size:18px; font-weight:700;
            }
        }
        .bd {
            .list {
                .item {
                    display:flex; justify-content: space-between; align-items: center; padding:25px 0; border-bottom:#e6e6e6 1px solid;
                    .item-icon {
                        width:32px;
                        .img {
                            width:28px; height:28px;
                        }
                    }
                    .item-info {
                        flex:1; padding:0 20px;
                        .info-title {
                            font-size:16px; font-weight:700; padding:0 0 4px;
                        }
                        .info-description {
                            color:#999;
                        }
                    }
                    .item-status {
                        width:200px;
                        .status {
                            .status-icon {
                                font-size:14px; margin-right:4px;
                            }
                            .text {
                                font-weight:700;
                            }
                            &.status-success {
                                .status-icon {color:#44ac30;}
                            }
                            &.status-error {
                                .status-icon {color:#f06c5d;}
                            }
                            &.status-warning {
                                .status-icon {color:#ffba40;}
                            }
                            &.status-default {
                                color:#999;
                                .status-icon {color:#999;}
                            }
                        }
                    }
                    .item-action {
                        padding:0 0 0 20px; width:100px; min-width:100px; text-align:right;
                    }
                }
            }
        }
    }
}
::v-deep .el-input-group__append {
                        background:transparent;
                        .el-button {
                            border-radius:0 4px 4px 0; color:#fff;
                            /*&.is-disabled {
                                opacity: .6;
                            }*/
                        }
                    }
</style>